// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home-splash-module--wrapper--A5-Le","imgWrapper":"home-splash-module--imgWrapper--3bM-p","logoWrapper":"home-splash-module--logoWrapper--33G8k"};